import { object, ObjectSchema, string } from 'yup';

import { PersonSource, PersonSourceExternalReferenceValue } from '@client/api';

const schema: ObjectSchema<PersonSourceExternalReferenceValue> = object({
  integration: string<PersonSource>().required(),
  identifier: string().required()
});

export { schema as personSourceExternalReferenceValueSchema };
